module.exports = __webpack_public_path__ + "img/btn_ASR_hover.72dbb374.png";